import { API_BASE_URL, ENDPOINTS } from '@/api/endpoints.js';

const fetchJson = async (endpoint, options = {}) => {
    const res = await fetch(`${API_BASE_URL}${endpoint}`, {
        ...options,
        headers: { 'Content-Type': 'application/json', ...options.headers },
        credentials: 'include', // cookie d'auth participant (httpOnly)
    });

    if (!res.ok) {
        const body = await res.text();
        let message;
        try { message = JSON.parse(body).message; } catch { message = body; }
        const err = new Error(message || `Erreur API ${res.status}`);
        err.status = res.status;
        throw err;
    }

    const text = await res.text();
    try { return text ? JSON.parse(text) : {}; } catch { return text; }
};

export const getQuizForContest = (contestId) =>
    fetchJson(ENDPOINTS.QUIZ.GET_FOR_CONTEST(contestId));

export const participateInQuiz = (contestId, answers, identity = null) =>
    fetchJson(ENDPOINTS.QUIZ.PARTICIPATE(contestId), {
        method: 'POST',
        body: JSON.stringify({ answers, ...(identity ?? {}) }),
    });
